module.exports = new __parcel__URL__("squad_text.0c63ea3c.png").toString();